import { NavLink } from "react-router-dom";
import type { AccountMenuModel } from "./useAccountMenuModel";

type AccountMenuContentProps = {
  model: AccountMenuModel;
  onClose(): void;
};

export function AccountMenuContent({ model, onClose }: AccountMenuContentProps) {
  return (
    <>
      <div className="account-menu__header">
        <p className="account-menu__user-name">{model.userName}</p>
        <p className="account-menu__user-meta">
          {model.isSystemOwner ? "System Owner" : "FSWL account"}
          <span aria-hidden="true"> · </span>
          {model.activeViewLabel}
        </p>
      </div>

      {model.showSwitchView ? (
        <div className="account-menu__section">
          <p className="account-menu__heading">Switch View</p>
          {model.switchableViews.map((view) => {
            const isActive = view === model.activeView;
            return (
              <button
                key={view}
                type="button"
                role="menuitemradio"
                aria-checked={isActive}
                className={`account-menu__item account-menu__item--view${isActive ? " is-active" : ""}`}
                onClick={() => {
                  model.switchToView(view);
                  onClose();
                }}
              >
                <span className="account-menu__check" aria-hidden="true">
                  {isActive ? "✓" : ""}
                </span>
                {view === "management" ? "Management" : "Staff"}
              </button>
            );
          })}
        </div>
      ) : null}

      <div className="account-menu__section">
        <NavLink role="menuitem" className="account-menu__item" to="/account/profile" onClick={onClose}>
          My Profile
        </NavLink>
        <NavLink role="menuitem" className="account-menu__item" to="/account/settings" onClick={onClose}>
          Account Settings
        </NavLink>
        <NavLink role="menuitem" className="account-menu__item" to="/account/security" onClick={onClose}>
          Security
        </NavLink>
      </div>

      <div className="account-menu__section">
        <p className="account-menu__heading">Theme</p>
        {model.themeOptions.map((option) => (
          <button
            key={option.mode}
            type="button"
            role="menuitemradio"
            aria-checked={model.themeMode === option.mode}
            className={`account-menu__item account-menu__item--compact${
              model.themeMode === option.mode ? " is-active" : ""
            }`}
            onClick={() => model.setThemeMode(option.mode)}
          >
            <span className="account-menu__check" aria-hidden="true">
              {model.themeMode === option.mode ? "✓" : ""}
            </span>
            {option.label}
          </button>
        ))}
      </div>

      <div className="account-menu__section account-menu__section--footer">
        <button
          type="button"
          role="menuitem"
          className="account-menu__item account-menu__item--danger"
          onClick={() => {
            void model.signOut();
            onClose();
          }}
        >
          Sign Out
        </button>
      </div>
    </>
  );
}
